import { render, staticRenderFns } from "./deepProItemList.vue?vue&type=template&id=07d72c42&scoped=true&"
import script from "./deepProItemList.vue?vue&type=script&lang=js&"
export * from "./deepProItemList.vue?vue&type=script&lang=js&"
import style0 from "./deepProItemList.vue?vue&type=style&index=0&id=07d72c42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d72c42",
  null
  
)

export default component.exports